const toCurrency =  (input) => {
  input.parentNode.setAttribute("comma-value", Number(input.value??0).toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
};
// const resetInput=(e)=>{
//   const input = e.target;
//   input.parentNode.setAttribute("comma-value", 0); 
// }
const selectText = (e)=>{
  e.target.select();
}
function NewNumberInput(props) {
  const { inputname, onChange, defaultValue, minvalue, value, customattr, readonly, reff, className, style, containerStyle, containerClassName, step, id } = props;
  const currency = Number(value ? value : (defaultValue ?? "0")).toLocaleString(navigator.language, { minimumFractionDigits: 0 });
  return (
    <div id={"comma_" + inputname} comma-value={currency} style={containerStyle} className={containerClassName}>
      {value !== undefined &&
        <input type="number" id={id} name={inputname} ref={reff} readOnly={readonly} className={(className ?? "") + " form-control"}
        onChange={(e) => { toCurrency(e.target); if (onChange) { onChange(e); } }} value={value} min={minvalue} {...customattr} style={style} step={step??1} onFocus={selectText}/>
      }
      {defaultValue !== undefined && value === undefined &&
        <input type="number" id={id} name={inputname} ref={reff} readOnly={readonly} className={(className ?? "") + " form-control"}
        onChange={(e) => { toCurrency(e.target); if (onChange) { onChange(e); } }} defaultValue={defaultValue} min={minvalue} {...customattr} style={style} step={step??1}  onFocus={selectText}/>
      }
      {defaultValue === undefined && value === undefined &&
        <input type="number" id={id} name={inputname} ref={reff} readOnly={readonly} className={(className ?? "") + " form-control"}
        onChange={(e) => { toCurrency(e.target); if (onChange) { onChange(e); } }} min={minvalue} {...customattr} style={style} step={step??1}  onFocus={selectText}/>
      }
    </div>
  )
}
export default NewNumberInput;